<template>
  <div class="jianbao_box">
    <m-title></m-title>
    <div class="cont">
    <div class="changdi">
      <div class="changditop">
        <div class="changdi_left">
          <span class="name">计划来源</span>
          <div class="select_box">
            <el-select v-model="changdival" placeholder="请选择"  @input="changdiselect">
              <el-option v-for="it in changdisel" :key="it.value" :value="it.value" :label="it.label"></el-option>
            </el-select>
          </div>
          <span class="name">计划号</span>
          <el-input placeholder="请输入" type="text" v-model="pno" class="inp" />
          <span class="name">货物</span>
          <el-input placeholder="请输入" type="text" v-model="goodsname" class="inp" />
          <span class="name">船名</span>
          <el-input placeholder="请输入" type="text" v-model="shipname" class="inp" />
          <span class="name">货主</span>
          <el-input placeholder="请输入" type="text" v-model="customname" class="inp" />
        </div>
        <div class="clear_search">
          <button class="chaxun" @click="getsearch">查询</button>
          <button class="reset" @click="reset">重置</button>
        </div>
      </div>
      <div class="changdibtn">
        <span class="name">时间</span>
        <el-date-picker v-model="starttime" type="date" class="inp" value-format="yyyy-MM-dd" placeholder="开始时间">
        </el-date-picker>
        <span class="name" style="margin-left: 0;">至</span>
        <el-date-picker v-model="endtime" type="date" class="inp" value-format="yyyy-MM-dd" placeholder="结束时间">
        </el-date-picker>
        <span class="name">计划状态</span>
          <div class="select_box">
            <el-select v-model="status" placeholder="请选择" >
              <el-option v-for="it in statusList" :key="it.value" :value="it.value" :label="it.label"></el-option>
            </el-select>
          </div>
          <span class="name">货代</span>
          <el-input placeholder="请输入" type="text" v-model="agentname" class="inp" />
      </div>
    </div>
    <div class="zuoyejianbao">
      <div class="echarts-title">
        <div class="left-bac"></div>
        <div class="left-name">作业简报</div>
      </div>
      <div class="zuoyedetails">
        <div class="jb zy1" style="color: #1B6B9B;cursor: pointer;" @click="godetail('jihua')">
          <div class="number">{{ jianbaoinfo.planedCount||0 }}</div>
          <div class="name">完成计划</div>
          <img src="../../assets/homeImg/icon_figer.png" alt="">
        </div>
        <div class="jb zy2" style="color: #2F419B ;" @click="godetail('chedui')">
          <div class="number">{{ jianbaoinfo.fleetCount||0 }}</div>
          <div class="name">运输车队</div>
        </div>
        <div class="jb zy3" style="color:#115B76;" @click="godetail('cheshu')">
          <div class="number">{{ jianbaoinfo.dispathCount||0 }}</div>
          <div class="name">派车数</div>
        </div>
        <div class="jb zy4" style="color: #533796;cursor: pointer;" @click="godetail('checi')">
          <div class="number">{{ jianbaoinfo.carWorkedCount||0 }}</div>
          <div class="name">运输车次</div>
          <img src="../../assets/homeImg/icon_figer.png" alt="">
        </div>
        <div class="jb zy5" style="color: #2F419B ;cursor: pointer;" @click="godetail('checi')">
          <div class="number">{{ jianbaoinfo.carWorkedDun||0 }}</div>
          <div class="name">运输吨数</div>
          <img src="../../assets/homeImg/icon_figer.png" alt="">
        </div>
      </div>
    </div>
    <div class="zuoyejianbao">
      <div class="titles">
        <div class="echarts-title">
          <div class="left-bac"></div>
          <div class="left-name">计划详情</div>
        </div>
        <button class="chaxun" @click="printListPno">导出</button>
      </div>
      
      <div class="zuoyedetail">
        <el-table style="width: 100%;margin-bottom: 10px;" :data="pnolist.list" max-height="380px" @cell-click="getchedui" :cell-style="cellcheduiStyle" border highlight-current-row>
          <el-table-column label="序号" type="index" width="50px" />
          <el-table-column prop="pno" label="计划号" show-overflow-tooltip />
          <el-table-column prop="status" label="计划状态" show-overflow-tooltip >
            <template v-slot="res">
              <span>{{getstatus(res.row.status) }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="shipname" label="船名" show-overflow-tooltip />
          <el-table-column prop="customname" label="货主" show-overflow-tooltip />
          <el-table-column prop="agentname" label="货代" show-overflow-tooltip />
          <el-table-column prop="customername" label="发货地" show-overflow-tooltip />
          <el-table-column prop="destination" label="发往地" show-overflow-tooltip />
          <el-table-column prop="goodsname" label="货物名称" show-overflow-tooltip />
          <el-table-column prop="plantons" label="计划吨数" show-overflow-tooltip />
          <el-table-column prop="workedSullte" label="实际完成吨" show-overflow-tooltip />
          <el-table-column label="完成时间" show-overflow-tooltip>
            <template v-slot="res">
              <span>{{ mydateFormat(res.row.endworkdate, '时分秒') }}</span>
            </template>
          </el-table-column>
        </el-table>
        <div class="msgstatistics">
          <span style="margin-right: 20px">计划合计:{{ pnolist.total }}条</span>
          <span>合计完成:{{ planTotal?planTotal.workedSullte:0}} 吨</span>
        </div>
        <el-pagination :page-size="limit" layout="total,prev, pager,next, jumper" :total="pnolist.total"
          :current-page="memberlistpno.page" @current-change="CurrentChangeJH" style="text-align: center;">
        </el-pagination>
      </div>
    </div>
    <div class="zuoyejianbao">
      <div class="titles">
        <div class="echarts-title">
          <div class="left-bac"></div>
          <div class="left-name">车队作业详情</div>
        </div>
        <button class="chaxun" @click="printListFleet">导出</button>
      </div>
      <div class="zuoyedetail">
        <el-table style="width: 100%;margin-bottom: 10px;" :data="fleetlist.list" max-height="380px" @cell-click="getcheliang" :cell-style="cellFleetStyle" border ref="table" highlight-current-row>
          <el-table-column label="序号" type="index" width="50px" />
          <el-table-column prop="shortname" label="车队名" show-overflow-tooltip />
          <el-table-column prop="shortname" label="车队简称" show-overflow-tooltip />
          <el-table-column prop="planedCount" label="完成计划数" show-overflow-tooltip />
          <el-table-column prop="carRegistCount" label="车队车数" show-overflow-tooltip />
          <el-table-column prop="trueDispathCount" label="派车数" show-overflow-tooltip />
          <el-table-column prop="dispathCount" label="实际运输车数" show-overflow-tooltip />
          <el-table-column prop="carWorkedCount" label="运输车次" show-overflow-tooltip />
          <el-table-column prop="carWorkedDun" label="运输货重(吨)" show-overflow-tooltip />
        </el-table>
        <div class="msgstatistics">
          <span style="margin-right: 20px">车队合计:{{ fleetlist.total }}个</span>
          <span style="margin-right: 20px">派车数合计:{{ fleetHj?fleetHj.trueDispathCount:0}} 次</span>
          <span style="margin-right: 20px">实际运输车数合计:{{ fleetHj?fleetHj.dispathCount:0}} 次</span>
          <span>合计完成:{{ fleetHj?fleetHj.carWorkedDun:0}} 吨</span>
        </div>
        <el-pagination :page-size="limit" layout="total,prev, pager,next, jumper" :total="fleetlist.total"
          :current-page="memberlistfleet.page" @current-change="CurrentChangeCD" style="text-align: center;">
        </el-pagination>
      </div>
    </div>
    <div class="zuoyejianbao">
      <div class="titles">
        <div class="echarts-title">
          <div class="left-bac"></div>
          <div class="left-name">车辆作业详情</div>
        </div>
        <button class="chaxun" @click="printListCar">导出</button>
      </div>
      <div class="zuoyedetail">
        <el-table style="width: 100%;margin-bottom: 10px;" :data="carlist.list" max-height="380px" border @cell-click="getbangdan" :cell-style="cellCarStyle" highlight-current-row>
          <el-table-column label="序号" type="index" width="50px" />
          <el-table-column prop="plate" label="车牌号" show-overflow-tooltip />
          <el-table-column prop="shortname" label="所属车队" show-overflow-tooltip />
          <el-table-column prop="planedCount" label="完成计划数" show-overflow-tooltip />
          <el-table-column prop="carWorkedCount" label="运输车次" show-overflow-tooltip />
          <el-table-column prop="carWorkedDun" label="运输货重" show-overflow-tooltip />
          <el-table-column prop="carWorkedCount" label="磅单数" show-overflow-tooltip >
            <!-- <template v-slot="res">
              <span @click="getbangdan(res.row)" style="cursor: pointer;">{{ res.row.carWorkedCount }}</span>
            </template> -->
          </el-table-column>
        </el-table>
        <div class="msgstatistics">
          <span style="margin-right: 20px">运营车辆合计:{{ carHj?carHj.fleetCarOnWorkCount:0 }}辆</span>
          <span style="margin-right: 20px">车次合计:{{ carHj?carHj.carWorkedCount:0}} 次</span>
          <span style="margin-right: 20px">磅单数合计:{{ carHj?carHj.carWorkedCount:0}} 次</span>
          <span>合计完成:{{ carHj?carHj.carWorkedDun:0}} 吨</span>
        </div>
        <el-pagination :page-size="carlimit" layout="total, sizes, prev, pager, next, jumper" :total="carlist.total" :page-sizes="[10, 15, 20]"
          :current-page="memberlistcar.page" @current-change="CurrentChangeCL"  @size-change="handleSizeChange" style="text-align: center;">
        </el-pagination>
      </div>
    </div>
  </div>
  <el-dialog :title="plate" :visible.sync="dialogTable" width="800px" @close="bangdanpage=1">
            <el-table :data="WeightList.list" height="300">
              <el-table-column prop="pno" label="计划号" width="120">
                </el-table-column>
                <el-table-column prop="suttle" label="装车吨数(吨)" width="120">
                    <template v-slot="scoped">
                        <div>
                            {{(scoped.row.suttle/1000).toFixed(2)||"-"}}
                        </div>
                    </template>
                </el-table-column>
                <el-table-column prop="roughWeight" label="过重吨数(吨)" width="120">
                    <template v-slot="scoped">
                        <div>
                            {{(scoped.row.roughWeight/1000).toFixed(2)||"-"}}
                        </div>
                    </template>
                </el-table-column>
                <el-table-column prop="tare" label="回皮吨数(吨)" width="120">
                    <template v-slot="scoped">
                        <div>
                            {{(scoped.row.tare/1000).toFixed(2)||"-"}}
                        </div>
                    </template>
                </el-table-column>
                <el-table-column prop="mwitemdate" label="过重时间" show-overflow-tooltip>
                    <template v-slot="scoped">
                        <div>
                          {{ mydateFormat(scoped.row.mwitemdate, "时分秒") }}
                        </div>
                    </template>
                </el-table-column>
                <el-table-column prop="pwitemdate" label="回皮时间" show-overflow-tooltip>
                    <template v-slot="scoped">
                        <div>
                          {{ mydateFormat(scoped.row.pwitemdate, "时分秒") }}
                        </div>
                    </template>
                </el-table-column>
            </el-table>
            
            <el-pagination layout="total,prev, pager,next, jumper" :page-size="limit" :total="WeightList.totalCount"
                :current-page.sync="bangdanpage" @current-change="dialogCurrentChange"></el-pagination>
        </el-dialog>
  </div>
</template>

<script>
import mTitle from '@/components/mTitle.vue';
import { printExcel } from '@/plugins/other.js';
export default {
  data() {
    return {
      changdisel:[
        { label: "前沿货场", value: "jiaotan" },
        { label: "港俊货场", value: "gangjun" },
        { label: "昊德", value: "haode" },
        { label: "琦晟", value: "qisheng" },
        { label: "睿鑫", value: "ruixin" },
        { label: "通达", value: "tongda" },
        { label: "富泉", value: "fuquan" },
      ],
      changdival: "jiaotan",
      statusList:[
        {label:'全部',value:null},
        { label: "进行中", value: 0 },
        { label: "已完成", value: 1 },
        { label: "暂停中", value: 2 },
        { label: "已作废", value: 3 }
      ],
      status:null,
      pno:null,
      goodsname:null,
      shipname:null,
      customname:null,
      agentname:null,
      starttime: null,
      endtime: null,
      pnolist:{},
      carlist:[],
      fleetlist:[],
      WeightList:[],
      jianbaoinfo:{},
      memberlistpno: {
        page: 1,
      },
      memberlistfleet: {
        page: 1,
      },
      memberlistcar: {
        page: 1,
      },
      limit: 10,
      carlimit:10,
      dialogTable:false,
      bangdanpage:1,
      truckId:"",
      plate:"",
      searchpno:null,
      shortname:"",
      planTotal:null,
      fleetHj:null,
      carHj:null
    }
  },
  components: {
    mTitle,
  },
  created() {
    if(this.$route.query.obj){
      this.changdival=JSON.parse(this.$route.query.obj).stname||'jiaotan'
      this.starttime=JSON.parse(this.$route.query.obj).startTime||null
      this.endtime=JSON.parse(this.$route.query.obj).endTime||null
      this.status=JSON.parse(this.$route.query.obj).status||null
      this.pno=JSON.parse(this.$route.query.obj).pno||null
      this.shortname=JSON.parse(this.$route.query.obj).fleetname||null
    }
  },
  mounted() {
    this.getsearch()
  },

  methods: {
    //导出 
    printListPno() {
      printExcel.call(
        this,
        '/fleet/plan/exportPlanListPcWorkReport',
        '计划详情',
        {
          stname:this.changdival,
          pno:this.pno,
          goodsname:this.goodsname,
          shipname:this.shipname,
          startTime:this.starttime,
          endTime:this.endtime,
          plantype:3,
          status:this.status
        },
      );
    },
    printListFleet() {
      printExcel.call(
        this,
        '/home/statistics/exportCarWorkSearch',
        '车队作业详情',
        {
          stname:this.changdival,
          pno:this.pno?this.pno:this.searchpno,
          cargoname:this.goodsname,
          shipname:this.shipname,
          starttime:this.starttime,
          endtime:this.endtime,
          type:1,
        },
        'get'
      );
    },
    printListCar() {
      printExcel.call(
        this,
        '/home/statistics/exportCarWorkSearch',
        '车辆作业详情',
        {
          stname:this.changdival,
          pno:this.pno?this.pno:this.searchpno,
          cargoname:this.goodsname,
          shipname:this.shipname,
          starttime:this.starttime,
          endtime:this.endtime,
          fleetname:this.shortname,
          type:2
        },
        'get'
      );
    },
    getstatus(val){
      let res
      switch (val) {
        case '0':
        res='进行中'
          break;
      
        case '1':
          res='已完成'
          break;
        case '2':
          res='暂停中'
          break;
        case '3':
          res='已作废'
          break;
      }
      return res
    },
    godetail(str){
      let name
      let {changdival,
      pno,
      goodsname,
      shipname,
      starttime,
      endtime}=this
      let obj={
        stname:changdival,
        pno,
        goodsname,
        shipname,
        // startTime:starttime,
        // endTime:endtime
      }
      switch (str) {
        case 'jihua':
          name="planlist"
          obj.plantype=3
          obj.status=1
          obj.selectVal='完成'
          obj.startTime=starttime?starttime+' '+'00:00:00':''
          obj.endTime=endtime?endtime+' '+'23:59:59':''
          break;
        // case 'chedui':
        //   // name="motorcade"
        //   name=""
        //   obj.corptype=1
        //   break;
        // case 'cheshu':
        //   name=""
        //   break;
        case 'checi':
          name="jobdetails"
          obj.plantype=3
          obj.startTime=starttime?starttime+' '+'00:00:00':''
          obj.endTime=endtime?endtime+' '+'23:59:59':''
          break;
      }
      this.$router.push({name,query:{obj:JSON.stringify(obj)}})
    },
    getbangdan(row,column){
      if(column.label==='磅单数'){
        this.plate=row.plate
        this.dialogTable=true
        this.getdialogtabel()
      }
      
    },
    cellCarStyle({row,column}){
      if(column.label==='磅单数'){
        return  "font-weight:700;color:#FF6100;cursor: pointer;";
      }
    },
    async getdialogtabel(){
      const {data}=await this.$http(
        "api1",
        "/driver/dispatchtruckdrivercar/listdetails", 
        "get", 
        { 
          plate:this.plate,
          stname:this.changdival,
          pno:this.pno?this.pno:this.searchpno,
          cargoname:this.goodsname,
          shipname:this.shipname,
          startTime:this.starttime,
          endTime:this.endtime,
          plantype:3,
          page:this.bangdanpage,
          limit:this.limit,
          storename:this.changdival
        })
      if (!data) return this.$message.error("获取数据失败");
      this.WeightList=data.data
    },
    dialogCurrentChange(val){
      this.bangdanpage=val
      this.getdialogtabel(this.truckId)
    },
    //选择货场
    changdiselect(e) {
      this.changdival = e
      // this.pagechange();
    },
    //查询
    getsearch() {
      this.getpnolist()
      this.getjianbao()
      this.getCar()
      this.getFleet()
    },
    //重置
    reset() {
      this.changdival= "jiaotan"
      this.pno=null
      this.goodsname=null
      this.shipname=null
      this.starttime= null
      this.endtime=null
      this.agentname=null
      this.customname=null
      this.shortname=""
      this.status=null
      this.memberlistpno.page=1
      this.memberlistfleet.page=1
      this.memberlistcar.page=1
      this.getsearch()
    },
    getchedui(row, column, cell, event) {
      if(column.label ==='计划号'){
        this.searchpno=row.pno
        this.shortname=""
        this.memberlistfleet.page=1
        this.memberlistcar.page=1
        this.getFleet(this.searchpno)
        this.getCar(this.searchpno)
      }
    },
    cellcheduiStyle({ row, column, rowIndex, columnIndex }){
      if (column.label === "计划号") {
                return "font-weight:700;color:#FF6100;cursor: pointer;";
            }
            return "";
    },
    getcheliang(row, column, cell, event) {
      if(column.label ==='车队名'){
        this.shortname=row.shortname
        this.memberlistcar.page=1
        this.getCar(this.searchpno,this.shortname)
      }
      
    },
    cellFleetStyle({ row, column, rowIndex, columnIndex }){
      if (column.label === "车队名") {
                return "font-weight:700;color:#FF6100;cursor: pointer;";
            }
            return "";
    },
    CurrentChangeJH(e) {
      this.memberlistpno.page=e
      this.getpnolist()
    },
    CurrentChangeCL(e) {
      this.memberlistcar.page=e
      this.getCar()
    },
    CurrentChangeCD(e) {
      this.memberlistfleet.page=e
      this.getFleet()
    },
    handleSizeChange(e){
      this.carlimit=e
      this.getCar()
    },
    //查询计划
    async getpnolist() {
      // let a,b
      // if(this.starttime||this.endtime){
      //   a=this.starttime.indexOf(' ')
      //   b=this.endtime.indexOf(' ')
      // }
      
      // console.log(a);
      // if(a>0||b>0){
      //   this.starttime=this.starttime.substring(0,a)
      //   this.endtime=this.endtime.substring(0,b)
      // }
      
      // console.log(this.starttime);
      const { data } = await this.$http(
        "api1",
        "/fleet/plan/planListPcWorkReport",
        "post",
        {
          stname:this.changdival,
          pno:this.pno,
          goodsname:this.goodsname,
          shipname:this.shipname,
          startTime:this.starttime,
          endTime:this.endtime,
          agentname:this.agentname,
          customname:this.customname,
          plantype:3,
          status:this.status,
          limit:this.limit,
          page:this.memberlistpno.page
        }
      );
      if (data.code != 0) return this.$message.error(data.msg);
      this.pnolist = data.data;
      this.planTotal=data.planTotal
    },
    //作业简报
    async getjianbao() {
      const { data } = await this.$http(
        "api1",
        "/home/statistics/numberReport",
        "get",
        {
          stname:this.changdival,
          pno:this.pno,
          cargoname:this.goodsname,
          shipname:this.shipname,
          starttime:this.starttime,
          endtime:this.endtime,
        }
      );
      if (data.code != 0) return this.$message.error(data.msg);
      this.jianbaoinfo=data.data[0]
    },
    async getCar(pno,shortname) {
      const { data } = await this.$http(
        "api1",
        "/home/statistics/carWorkSearch",
        "get",
        {
          stname:this.changdival,
          pno:pno?pno:this.pno?this.pno:this.searchpno,
          cargoname:this.goodsname,
          shipname:this.shipname,
          starttime:this.starttime,
          endtime:this.endtime,
          fleetname:shortname||this.shortname,
          type:2,
          limit:this.carlimit,
          page:this.memberlistcar.page
        }
      );
      if (data.code != 0) return this.$message.error(data.msg);
      this.carlist=data.data
      this.carHj=data.hj
    },
    async getFleet(pno) {
      const { data } = await this.$http(
        "api1",
        "/home/statistics/carWorkSearch",
        "get",
        {
          stname:this.changdival,
          pno:pno?pno:this.pno,
          cargoname:this.goodsname,
          shipname:this.shipname,
          starttime:this.starttime,
          endtime:this.endtime,
          type:1,
          limit:this.limit,
          page:this.memberlistfleet.page
        }
      );
      if (data.code != 0) return this.$message.error(data.msg);
      this.fleetlist=data.data
      this.fleetHj=data.hj
      if(this.shortname){
        let index=data.data.list.findIndex(item=>item.shortname===this.shortname)
        this.$nextTick(()=>{
          this.$refs.table.setCurrentRow(this.fleetlist.list[index])
        })
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.el-table .warning-row {
    background: oldlace;
  }
.jianbao_box {
  
  width: 100%;
  height: 100%;
 
.cont{
  position: relative;
  width: 100%;
  height: calc(100% - 50px);
  overflow: auto;
  background-color: #f5f6fa;
  padding: 10px;
  box-sizing: border-box;
  .changdi {
    width: 100%;
      background-color: #fff;
      margin: 10px 0;
      padding: 20px ;
      box-sizing: border-box;
      border-radius: 8px;
    .changditop {
      
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-bottom: 20px;

      .changdi_left {
        display: flex;
        justify-content: flex-start;
        align-items: center;

        .inp {
          width: 150px;
          height: 30px;
        }

        .name {
          font-size: 14px;
          margin:0 10px;
        }

        .select_box {
          display: inline-block;
          font-weight: 400;
          width: 120px;
          height: 30px;
          vertical-align: middle;
          margin-left: 10px;
          background: #f3f4f5;
          line-height: 30px;
        }

      }

      .clear_search {
        .chaxun {
          width: 80px;
          height: 30px;
          background: #17B6A1;
          border-radius: 8px;
          color: #fff;
          line-height: 30px;
          text-align: center;
          border: none;
          font-size: 80%;
        }

        .reset {
          width: 80px;
          height: 30px;
          background-color: #F5F6FA;
          border-radius: 8px;
          color: #17B6A1;
          line-height: 30px;
          text-align: center;
          border: none;
          font-size: 80%;
          margin-left: 19px;
        }
      }
    }
    .changdibtn{
      display: flex;
      justify-content: flex-start;
      align-items: center;
      .name{
        font-size: 14px;
          margin:0 10px;
      }
      .inp {
          width: 150px;
          height: 30px;
        }
        .select_box {
          display: inline-block;
          font-weight: 400;
          width: 120px;
          height: 30px;
          vertical-align: middle;
          margin-left: 10px;
          background: #f3f4f5;
          line-height: 30px;
        }
    }
  }

  .yunshutongji,
  .zuoyejianbao {
    width: 100%;
    background: #FFFFFF;
    border-radius: 8px;
    margin-top: 20px;
    padding: 0 34px;
    box-sizing: border-box;
    .echarts-title {
        padding: 10px 0 ;
        box-sizing: border-box;
        display: flex;
        justify-content: flex-start;
        align-items: center;

        .left-bac {
          width: 12px;
          height: 26px;
          background: #17B6A1;
          border-radius: 6px;
          margin-right: 11px;
        }

        .left-name {
          font-size: 100%;
          font-family: PingFang SC;
          font-weight: 600;
          color: #2D3748;
        }
      }
    .titles{
      display: flex;
      justify-content: space-between;
      align-items: center;
      .echarts-title {
        padding: 10px 0 ;
        box-sizing: border-box;
        display: flex;
        justify-content: flex-start;
        align-items: center;

        .left-bac {
          width: 12px;
          height: 26px;
          background: #17B6A1;
          border-radius: 6px;
          margin-right: 11px;
        }

        .left-name {
          font-size: 100%;
          font-family: PingFang SC;
          font-weight: 600;
          color: #2D3748;
        }
      }
      .chaxun {
          width: 80px;
          height: 30px;
          background: #17B6A1;
          border-radius: 8px;
          color: #fff;
          line-height: 30px;
          text-align: center;
          border: none;
          font-size: 80%;
        }
    }
    

    .zuoyedetail {
      padding-bottom: 10px;
      .msgstatistics{

        font-size: 80%;
        line-height: 35px;
        text-align: center;
        color: #fff;
        font-weight: bold;
        background: #17B6A1;
      }
    }

    .zuoyedetails {
      padding-bottom: 10px;
      display: flex;
      justify-content: space-evenly;

      .jb {
        width: 19%;
        aspect-ratio:2/1;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        position: relative;
        .number {
          font-size: 30px;
          font-weight: 600;
          margin-bottom: 15px;
        }

        .name {
          font-size: 14px;
        }
        img{
          width: 20px;
          height: 30px;
          position: absolute;
          right: 15px;
          bottom: 15px;
        }
      }

      @for $i from 1 through 5 {
        .zy#{$i} {
          background-image: url(../../assets/zuoye/zy#{$i}.png);
          background-size: 100% 100%;
          background-repeat: no-repeat
        }
      }

    }
  }
}
  
}
</style>